// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"TagView_dropdown__1y4J8","darkDropdown":"TagView_darkDropdown__7casB","newTagDropdown":"TagView_newTagDropdown__yZmJy"};